import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TAppStore } from '../types/apps-store.type';

/**
 * Send Credential App Store Channel Input Schema
 */
export const sendCredentialAppStoreChannelValidationSchema = z.object({
  issuer_id: z.string({ required_error: 'Issuer ID is required' }),
  key_id: z.string({ required_error: 'API Key ID is required' }),
  privateKeyFile: z.any({ required_error: 'Private Key File is required' }),
});

export type TSendCredentialAppStoreChannelValidation = z.infer<typeof sendCredentialAppStoreChannelValidationSchema>;
export type TSendCredentialAppStoreChannelPayload = TSendCredentialAppStoreChannelValidation;
export type TSendCredentialAppStoreChannelResponse = ApiResponse<TAppStore[]>;

export const sendCredentialAppStoreChannel = async (
  payload: TSendCredentialAppStoreChannelPayload
): Promise<TSendCredentialAppStoreChannelResponse> => {
  const url = `/integration/appstore/connect`;

  const payloadData = new FormData();
  payloadData.append('issuer_id', payload.issuer_id);
  payloadData.append('key_id', payload.key_id);
  payloadData.append('privateKeyFile', payload.privateKeyFile);

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };

  return axiosInstance.post(url, payloadData, config);
};

/**
 * Use Send Credential App Store Channel Mutation   React-Query Hook
 */
type TUseSendCredentialAppStoreChannelMutation = {
  mutationConfig?: TypedMutationConfig<typeof sendCredentialAppStoreChannel, AxiosErrorCustom>;
};

/**
 * Use Send Credential App Store Channel React-Query Hook
 */
export const useSendCredentialAppStoreChannelMutation = ({
  mutationConfig,
}: TUseSendCredentialAppStoreChannelMutation) => {
  const { ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: sendCredentialAppStoreChannel,
    ...restConfig,
  });
};
